import {
    createRegisterableComponent,
    createRegisterableComponentWithData,
    EditionLoader,
    useFeature,
} from '@news-mono/web-common'
import React, { lazy } from 'react'
import {
    SpecialEditionHome,
    SpecialEditionHomeProps,
    TheNightlyOnHome,
} from './SpecialEditionHome'

export interface SpecialEditionHomeRouteProps {
    publicationTitle: string
    title?: string // deprecated
    teaser?: string // deprecated
    link?: string // deprecated
    imageURL?: string // deprecated
    lazyloadImages?: boolean
}

export const NightlySpecialEditionHomeRegistration =
    createRegisterableComponentWithData(
        'nightly-special-edition-home',
        EditionLoader,
        (
            {
                title,
                publicationTitle,
                teaser,
                link,
                imageURL,
                lazyloadImages,
            }: SpecialEditionHomeRouteProps,
            data,
            services,
        ) => {
            //@feature-flag cleanup: remove this when 'The Nightly On' Editions are published via CUE
            const useEditionItem = useFeature('the-nightly-on-cue-publication')

            if (useEditionItem) {
                if (!data.loaded) return null
                const edition = data.result.documents?.[0]
                if (!edition) {
                    services?.log?.error(
                        data,
                        'SpecialEditionHome: empty result',
                    )
                    return null
                }

                return (
                    <SpecialEditionHome
                        edition={edition}
                        publicationTitle={publicationTitle}
                        lazyloadImages={lazyloadImages}
                    />
                )
            } else {
                if (!title || !teaser || !link || !imageURL) {
                    services?.log?.error(
                        'TheNightlyOnHome: missing required props',
                    )
                    return null
                }

                return (
                    <TheNightlyOnHome
                        title={title}
                        teaser={teaser}
                        link={link}
                        imageURL={imageURL}
                        lazyloadImages={lazyloadImages}
                    />
                )
            }
        },
    )
